import { loadStateData } from './../Storage';
import Auth from './../Auth';
import { GHOST_MODE_TYPE_MERCHANT } from './../../constants/modes';
import { hasAccess } from '../AccessMerchant';

export default ({ dispatch, getState }, request = {}, accessRules) =>
  ({ params, location = {} }, replace, callback) => {
    const urlQuery = location.query;
    const state = getState();
    const requestName = request.name;
    const options = request.options || {};
    const { filter } = loadStateData() || {};
    const isHasUserData = state.global.data.user;
    const { defaultMerchant: { id: defaultMerchantId } = {} } =
      state.global.data.profile || {};
    const { type: ghostType } = state.global.data.ghost || {};
    const { id: merchantId = defaultMerchantId } = state.portalApp.selectedAccount || {};
    const isAllowed = hasAccess({ merchantId, accessRules });
    const isGhostMerchant = ghostType === GHOST_MODE_TYPE_MERCHANT;

    const query = {
      ...params,
      ...request.query,
      ...(filter || {})[requestName],
      ...urlQuery
    };
    const conditions = [
      {
        condition: isHasUserData && !Auth.isUserAuthenticated(),
        action: () => dispatch({ type: 'RESET' })
      },
      {
        condition: requestName !== 'redirectLogin' && !(isAllowed || isGhostMerchant),
        action: () => replace('/denied')
      },
      {
        condition:
          (requestName === 'redirectLogin' && Reflect.has(urlQuery, 'redirect_token')) ||
          (requestName !== 'redirectLogin' && (isAllowed || isGhostMerchant)),
        action: () =>
          dispatch({
            type: 'FETCH_REQUEST',
            payload: { name: requestName, query, options }
          })
      }
    ];
    conditions
      .filter(({ condition }) => condition === true)
      .forEach(({ action }) => action());

    return callback();
  };
